import * as React from 'react';
import { useState } from 'react';
import i18next from 'i18next';
import { Metric } from '../../items';
import styles from './styles.module.scss';

interface Props {
  title: string;
  /** Charts that can show the investment get a Cantidad / Inversión switch; the others always count. */
  switchable: boolean;
  children: (metric: Metric) => React.ReactNode;
}

const METRICS: Metric[] = ['count', 'investment'];

/** A titled chart with its own choice of what it measures. */
const ChartCard = ({ title, switchable, children }: Props) => {
  const [metric, setMetric] = useState<Metric>('count');

  return (
    <section className={styles.card}>
      <h3 className={styles.title}>{title}</h3>
      {!switchable && <div className={styles.spacer} aria-hidden="true" />}
      {switchable && (
        <div className={styles.switch} role="group" aria-label={i18next.t('analytics:measure') as string}>
          {METRICS.map(option => (
            <button
              key={option}
              type="button"
              className={option === metric ? styles.active : undefined}
              aria-pressed={option === metric}
              onClick={() => setMetric(option)}
            >
              {i18next.t(`analytics:${option}`)}
            </button>
          ))}
        </div>
      )}
      {children(switchable ? metric : 'count')}
    </section>
  );
};

export default ChartCard;
